(function ($) {
	$.contentSection = function (element, options) {
		// **************************************************************
		// Public Properties
		// **************************************************************

		var $c = $(element), // Context 

			ContentSection = (function ($c, o) {
				var defaults = {

				}; 

				var _o = {}
				;

				var _InitObjects = function () {
					_o = $.extend({}, defaults, o);
				},

				_OnWayPoint = function(direction) {
					if (direction === 'down') {
						$c.addClass('inview');
					} else {
						$c.removeClass('inview');
					}
				},

				_BindEvents = function () {
					// Set waypoint
					wp = new Waypoint({
						element:  $c.get(0),
						handler: _OnWayPoint,
						offset: '70%'
					});
				},

				init = (function() {
					_InitObjects();
					_BindEvents();
				})();
			}) ($c, options);
	};

	$.fn.contentSection = function (options) {
		return this.each(function () {
			if (undefined === $(this).data('contentSection')) {
				var plugin = new $.contentSection(this, options);
				$(this).data('contentSection', plugin);
			}
		});
	};
})(jQuery);
